import {VersionHistory} from '@domain/product-configuration/version-history';
import {StringUtils} from '@vdw/angular-component-library';
import {SelectListProductConfigurationWeaveQuality} from './select-list-product-configuration-weave-quality';

export class SelectListProductConfigurationVersionHistory extends VersionHistory {
  private readonly _weaveQuality: SelectListProductConfigurationWeaveQuality;

  public constructor(
    weaveQuality: SelectListProductConfigurationWeaveQuality,
    dateModified: Date,
    version: number,
    changes: string,
    readyForProduction: boolean,
    additionalInformation: string,
    weaveStructureName: string,
    weaveStructureVersion: number,
    qualityName: string,
    qualityVersion: number
  ) {
    super(dateModified, version, changes, readyForProduction, additionalInformation, weaveStructureName, weaveStructureVersion, qualityName, qualityVersion);

    this._weaveQuality = weaveQuality;
  }

  public get weaveQuality(): SelectListProductConfigurationWeaveQuality {
    return this._weaveQuality;
  }

  public static fromJSON(versionHistoryJSON: any): SelectListProductConfigurationVersionHistory {
    return new SelectListProductConfigurationVersionHistory(
      SelectListProductConfigurationWeaveQuality.fromJSON(versionHistoryJSON.quality),
      StringUtils.toDate(versionHistoryJSON.dateModified),
      versionHistoryJSON.version,
      versionHistoryJSON.changes,
      versionHistoryJSON.readyForProduction,
      versionHistoryJSON.additionalInformation,
      versionHistoryJSON.weaveStructureName,
      versionHistoryJSON.weaveStructureVersion,
      versionHistoryJSON.qualityName,
      versionHistoryJSON.qualityVersion
    );
  }
}
